import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule, ValidationErrorModule } from '@lib/components';
import { StaticMsgModule } from '@lib/pipes';
import { LinkedModalComponent } from './linked-modal.component';

@NgModule({
  declarations: [LinkedModalComponent],
  imports: [CommonModule, ButtonModule, StaticMsgModule, FormsModule, ReactiveFormsModule, ValidationErrorModule],
  exports: [LinkedModalComponent],
})
export class LinkedModalModule {}
